import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import {
    COLOR,
    blackTransparent,
    lightGrey,
    whiteTransparent,
} from 'utils/colors';
import { HEADER_HEIGHT } from 'utils/hooks/useHeaderHeight';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    safeArea: {
        flex: 1,
        backgroundColor: blackTransparent(0.95),
        marginBottom: androidScreenMarginBottom,
    },
    header: {
        height: HEADER_HEIGHT,
        justifyContent: 'center',
        alignItems: 'flex-end',
        borderBottomWidth: isTabletOrWeb ? 0 : 1,
        borderBottomColor: whiteTransparent(0.1),
        backgroundColor: isTabletOrWeb ? 'transparent' : COLOR.BLACK,
        zIndex: 1,
    },
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    scrollContainer: {
        flexGrow: 1,
        justifyContent: 'center',
        paddingBottom: heightPercentageToDP(120, 100, 72),
        backgroundColor: 'transparent',
    },
    titleText: {
        marginTop: Platform.select({
            ios: heightPercentageToDP(48),
            default: heightPercentageToDP(25),
        }),
        marginHorizontal: widthPercentageToDP(16, 240, 400),
        fontFamily: Fonts.main.bold,
        fontSize: 24,
        lineHeight: 32,
        color: lightGrey(),
        alignSelf: 'flex-start',
    },
    metadataText: {
        marginTop: heightPercentageToDP(12),
        marginHorizontal: widthPercentageToDP(16, 240, 400),
        alignSelf: 'flex-start',
        fontFamily: Fonts.main.regular,
        fontSize: 14,
        color: lightGrey(),
        textAlign: 'left',
        lineHeight: 20,
    },
    descriptionText: {
        height: 'auto',
        marginHorizontal: widthPercentageToDP(16, 240, 400),
        marginTop: heightPercentageToDP(11),
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        lineHeight: 24,
        color: lightGrey(),
        alignSelf: 'flex-start',
    },
    closeButton: {
        width: widthPercentageToDP(30),
        aspectRatio: 1,
        marginRight: 12,
    },
    topGradient: {
        position: 'absolute',
        top: -HEADER_HEIGHT,
        left: 0,
        right: 0,
        height: 100,
    },
    bottomGradient: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 88,
    },
});

export default styles;
